import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Loader2, Calendar, FileText } from "lucide-react";
import { ReportBody } from "./reports/ReportBlocks";

const API = process.env.REACT_APP_BACKEND_URL;

async function fetchPublic(token) {
  const r = await axios.get(`${API}/api/public/reports/${token}`);
  return r.data;
}

function fmtDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("es-AR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
}

export default function PublicReport() {
  const { token } = useParams();
  const q = useQuery({ queryKey: ["public-report", token], queryFn: () => fetchPublic(token) });

  if (q.isLoading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (q.isError) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-600">Reporte no encontrado o link inválido.</div>;

  const r = q.data;
  const Icon = r.kind === "weekly" ? Calendar : FileText;
  return (
    <div className="min-h-screen bg-slate-50 py-10">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-md border border-slate-200 p-6 mb-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-md bg-slate-100 border border-slate-200 flex items-center justify-center">
              <Icon className="h-5 w-5 text-slate-500" />
            </div>
            <div>
              <h1 className="font-display text-xl font-semibold text-slate-900">
                Reporte {r.kind === "weekly" ? "semanal" : "mensual"} · {r.client_name}
              </h1>
              <div className="text-xs text-slate-500 mt-0.5">{fmtDate(r.period_start)} → {fmtDate(r.period_end)}</div>
            </div>
          </div>
        </div>

        <ReportBody snapshot={r.snapshot} kind={r.kind} periodStart={r.period_start} periodEnd={r.period_end} />

        {r.notes && (
          <section className="bg-white rounded-md border border-slate-200 p-5 mt-4">
            <h2 className="font-display text-sm font-semibold text-slate-900 mb-3">Notas del account manager</h2>
            <p className="text-sm text-slate-700 whitespace-pre-wrap">{r.notes}</p>
          </section>
        )}

        <div className="mt-6 text-center text-[11px] text-slate-400">Snapshot congelado el {fmtDate(r.generated_at)} · Narwhal Hub</div>
      </div>
    </div>
  );
}
